var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCallback } from 'react';
import { useMutation } from '@apollo/client';
import { checkForErrors } from 'utils/helpers';
import { message } from 'antd';
export var safeRunMutation = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var r, isErrorFree, e_1;
    var mutate = _b.mutate, payload = _b.payload, responsePath = _b.responsePath, successMessage = _b.successMessage, context = _b.context, optimisticResponse = _b.optimisticResponse;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 2, , 3]);
                return [4 /*yield*/, mutate({
                        variables: __assign({}, payload),
                        context: context,
                        optimisticResponse: optimisticResponse
                    })];
            case 1:
                r = _c.sent();
                isErrorFree = checkForErrors(['data', responsePath], r);
                if (isErrorFree && !!successMessage)
                    message.success(successMessage);
                return [2 /*return*/, { r: r, isErrorFree: isErrorFree }];
            case 2:
                e_1 = _c.sent();
                return [2 /*return*/, { isErrorFree: false }];
            case 3: return [2 /*return*/];
        }
    });
}); };
// TODO: Add 'update' handler that uses cache.modify to add new items w/o refetch
export var useSafeRunMutation = function (_a) {
    var mutation = _a.mutation, responsePath = _a.responsePath, successMessage = _a.successMessage, refetchQueries = _a.refetchQueries, update = _a.update, errorPolicy = _a.errorPolicy;
    // Cast update to Apollo's expected type to avoid TS errors
    var _b = useMutation(mutation, {
        refetchQueries: refetchQueries,
        update: update
    }), mutate = _b[0], loading = _b[1].loading;
    var onMutate = useCallback(function (variables, context) { return __awaiter(void 0, void 0, void 0, function () {
        var r, isErrorFree, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, mutate({ variables: variables, errorPolicy: errorPolicy, context: context })];
                case 1:
                    r = _a.sent();
                    isErrorFree = checkForErrors(['data', responsePath], r);
                    if (isErrorFree && !!successMessage)
                        message.success(successMessage);
                    return [2 /*return*/, { r: r, isErrorFree: isErrorFree }];
                case 2:
                    e_2 = _a.sent();
                    return [2 /*return*/, { isErrorFree: false }];
                case 3: return [2 /*return*/];
            }
        });
    }); }, [mutate, errorPolicy, responsePath, successMessage]);
    return { onMutate: onMutate, loading: loading };
};
// What useCustomMutation hook does
// 1. Generates the mutation function
// 2. Based on attributes provided, generates attributes needed
// ^ Be careful, attribute name is not always same as field in the response.
//   name directive based on attribute you about to send and use it to include
//   appropriate field
// 3. Safely runs the mutation
export var useCustomMutation = function (_a) {
    var mutation = _a.mutation, successMessage = _a.successMessage, responsePath = _a.responsePath;
    var _b = useMutation(mutation), mutate = _b[0], loading = _b[1].loading;
    var onMutate = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
        var reduceDirectives, directivesSource, directives, payload, _c, r, isErrorFree;
        var id = _b.id, attributes = _b.attributes, _d = _b.forcedAttributes, forcedAttributes = _d === void 0 ? undefined : _d, _e = _b.context, context = _e === void 0 ? undefined : _e, _f = _b.optimisticResponse, optimisticResponse = _f === void 0 ? undefined : _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    reduceDirectives = function (array) {
                        return array.reduce(function (acc, v) {
                            var _a;
                            return (__assign(__assign({}, acc), (_a = {}, _a["include_".concat(v)] = true, _a)));
                        }, {});
                    };
                    directivesSource = forcedAttributes || Object.keys(attributes);
                    directives = reduceDirectives(directivesSource);
                    payload = __assign({ id: id, attributes: attributes }, directives);
                    return [4 /*yield*/, safeRunMutation({
                            mutate: mutate,
                            payload: payload,
                            responsePath: responsePath,
                            successMessage: successMessage,
                            context: context,
                            optimisticResponse: optimisticResponse
                        })];
                case 1:
                    _c = _g.sent(), r = _c.r, isErrorFree = _c.isErrorFree;
                    return [2 /*return*/, { r: r, isErrorFree: isErrorFree }];
            }
        });
    }); };
    return { onMutate: onMutate, loading: loading };
};
